export const ADD_NEW_ITEM_TO_BASKET = "ADD_NEW_ITEM_TO_BASKET";
export const UPDATE_ITEM_ON_BASKET = "UPDATE_ITEM_ON_BASKET";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const RESET_BASKET = "RESET_BASKET";
export const SHOW_CART = "SHOW_CART";
export const HIDE_CART = "HIDE_CART";
export const SYNC_CART = "SYNC_CART";
export const RELOAD_CART = "RELOAD_CART";
